<template>
  <div
    v-b-tooltip.hover="{ title: tooltipTitle, placement: tooltipPlacement }"
    class="circular-countdown"
  >
    <svg :width="size" :height="size" class="countdown-svg">
      <circle
        :r="radius"
        :cx="center"
        :cy="center"
        class="countdown-circle-bg"
        :stroke-width="strokeWidth"
      />
      <circle
        :r="radius"
        :cx="center"
        :cy="center"
        class="countdown-circle-progress"
        :stroke-width="strokeWidth"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
        :style="{ transition: isRunning ? 'stroke-dashoffset 1s linear' : 'none' }"
      />
      <text
        :x="center"
        :y="center"
        class="countdown-text"
        text-anchor="middle"
        dominant-baseline="middle"
      >
        {{ timeLeft }}
      </text>
    </svg>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import { VBTooltip } from 'bootstrap-vue';

export default {
  name: 'CircularCountdown',
  props: {
    duration: {
      type: Number,
      default: 60,
    },
    size: {
      type: Number,
      default: 120,
    },
    strokeWidth: {
      type: Number,
      default: 8,
    },
    autoStart: {
      type: Boolean,
      default: true,
    },
    restartOnComplete: {
      type: Boolean,
      default: false,
    },
    tooltipTitle: {
      type: String,
      default: '',
    },
    tooltipPlacement: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {
      timeLeft: this.duration,
      interval: null,
      isRunning: false,
    }
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    radius() {
      return (this.size - this.strokeWidth) / 2
    },
    center() {
      return this.size / 2
    },
    circumference() {
      return 2 * Math.PI * this.radius
    },
    dashOffset() {
      const progress = this.timeLeft / this.duration
      return this.circumference * (1 - progress)
    },
  },
  mounted() {
    if (this.autoStart) {
      this.start()
    }

    EventBus.$on('restart-countdown', this.restart);
  },
  beforeDestroy() {
    EventBus.$off('restart-countdown', this.restart);
    this.stop()
  },
  methods: {
    start() {
      if (this.isRunning) return
      
      this.isRunning = true
      this.interval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          this.stop()
          this.$emit('complete')
          if (this.restartOnComplete) {
            this.restart()
          }
        }
      }, 1000)
    },
    stop() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
        this.isRunning = false
      }
    },
    reset() {
      this.stop()
      this.timeLeft = this.duration
    },
    restart() {
      this.reset()
      this.start()
    },
  },
}
</script>

<style scoped>
.circular-countdown {
  display: inline-block;
}

.countdown-svg {
  transform: rotate(-90deg);
}

.countdown-circle-bg {
  fill: none;
  stroke: #e0e0e0;
}

.countdown-circle-progress {
  fill: none;
  stroke: #7367f0;
  stroke-linecap: round;
}

.countdown-text {
  transform: rotate(90deg);
  transform-origin: center;
  font-size: 12px;
  font-weight: bold;
  fill: #7367f0;
}
</style>
